import { isCompanyCodeConfigured } from './isCompanyCodeConfigured';

export function isLetterGenerationRestricted(
  companyCode: string,
  templateName: string | null | undefined,
  configuredCompanyCodes: string,
  configuredTemplateNames: string
): boolean {
  if (!templateName || !configuredTemplateNames) return false;

  const normalizedTemplateName = templateName.trim().toLowerCase();
  const restrictedTemplateNames = configuredTemplateNames
    .split(',')
    .map((name) => name.trim().toLowerCase())
    .filter(Boolean);

  return restrictedTemplateNames.includes(normalizedTemplateName) &&
    isCompanyCodeConfigured(companyCode, configuredCompanyCodes);
}